import React from 'react';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    type = 'button',
    disabled = false,
    className = ''
}) => {
    const baseStyles = 'font-medium transition-all duration-300 rounded-sm flex items-center justify-center tracking-wider uppercase';

    const variants = {
        primary: 'bg-[#1B4965] text-white hover:bg-[#133B53] active:bg-[#0F2D40] disabled:bg-[#1B4965]/50',
        secondary: 'bg-white text-[#1B4965] border border-[#1B4965] hover:bg-[#1B4965] hover:text-white active:bg-[#133B53]',
        teal: 'bg-[#62B6CB] text-white hover:bg-[#4FA3B8] active:bg-[#3D919F] disabled:bg-[#62B6CB]/50',
        outline: 'bg-transparent text-[#1B4965] border border-[#E5E7EB] hover:border-[#1B4965] hover:bg-[#F0F7FA]',
        ghost: 'bg-transparent text-[#1B4965] hover:bg-[#F0F7FA]',
    };

    const sizes = {
        sm: 'px-4 py-2 text-xs',
        md: 'px-6 py-2.5 text-sm',
        lg: 'px-8 py-3.5 text-sm',
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseStyles} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${fullWidth ? 'w-full' : ''} ${className}`}
            style={{ fontFamily: "'Work Sans', sans-serif" }}
        >
            {children}
        </button>
    );
};

export default Button;
